// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"d99285f2","545":"a5b4777a","551":"a22a53b6","605":"a92e54b2","662":"a1da5755","766":"99e20d7b"}[chunkId] + ".chunk.js";
};